export default {
  calculateCoordinates(rightSide, leftSide, yRatio = 0.866) {
    return {
      x: (rightSide + (leftSide / 2)),
      y: leftSide * yRatio,
    };
  },
  /**
   * Calcula as coordenadas do triangulo de duval referente ao tipo de triangulo.
   * @param { percentageC2H4: Number, percentageCH4: Number } data
   * @return { x: Number, y: Number} True se todas as permissões puderam ser aplicadas.
   * False se alguma permissão foi negada devido ao usuário logado não possuí-la.
   */
  getTriangle1Coordinates(data) {
    return this.calculateCoordinates(data.percentageC2H4, data.percentageCH4);
  },
  /**
   * Calcula as coordenadas do triangulo de duval referente ao tipo de triangulo.
   * @param { percentageCH4: Number, percentageH2: Number } data
   * @return { x: Number, y: Number} True se todas as permissões puderam ser aplicadas.
   * False se alguma permissão foi negada devido ao usuário logado não possuí-la.
   */
  getTriangle4Coordinates(data) {
    return this.calculateCoordinates(data.percentageCH4, data.percentageH2);
  },
  /**
   * Calcula as coordenadas do triangulo de duval referente ao tipo de triangulo.
   * @param { percentageC2H4: Number, percentageCH4: Number } data
   * @return { x: Number, y: Number} True se todas as permissões puderam ser aplicadas.
   * False se alguma permissão foi negada devido ao usuário logado não possuí-la.
   */
  getTriangle5Coordinates(data) {
    return this.calculateCoordinates(data.percentageC2H4, data.percentageCH4);
  },
};
